const INITIAL_STATE = {
  orders: [],
  cancelOrder: false,
  loadingCancel: false,
  ordersStatus: {
    step: null,
    titleStatus: null,
    status: null
  }
}

export const Creators = {
  setOrders: (data) => ({
    type: 'SET_ORDERS',
    orders: data,
  }),
};

export default function statusReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_ORDERS':
      return {
        ...state,
        orders: action.orders
      }
    case 'CANCELED_ORDER':
      return {
        ...state,
        cancelOrder: action.cancelOrder
      } 
    case 'LOADING_CANCEL': 
      return {
        ...state,
        loadingCancel: action.loadingCancel
      }
    case 'RESET':
      return {
        orders: [],
        cancelOrder: false
      }
    case 'SET_STATUSORDER': 
      return {
        ...state,
        ordersStatus: {
          step: action.order.step,
          titleStatus: action.order.titleStatus,
          status: action.order.status,
          occupationStatus: action.order.occupationStatus,
          statusFromApi: action.order.statusFromApi
        }
      }
    default:
      return state;
  }
}
